<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-fornecedor') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="fornecedoresSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="empresas"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="fornecedoresSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idfornecedor === linha.idfornecedor"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssPodutoFornecedorService from "@/services/vendas/produto/AssProdutoFornecedorService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idProduto: 0,
    },
    data() {
        return {
            service: new AssPodutoFornecedorService(this.$http, this.$router),
            empresas: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                {key: 'nome', width: null, sortable: true, sortFn: null},
                {key: 'rsocial', width: null, sortable: true, sortFn: null},
                {key: 'email', width: null, sortable: true, sortFn: null},
            ],
            fornecedoresSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            multiplicador: 1,
            multiplicadortroca:1,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.service
            .findFornecedorNaoAssociadosProduto(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idProduto,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.empresas = value;
                this.isEmpty = this.empresas.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        multiplicadorUpdate(value){
            this.multiplicador = value;
        },
        multiplicadortrocaUpdate(value){
            this.multiplicadortroca = value;
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idfornecedor: m.idfornecedor,
                    replicapda: m.replicapda,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    email: m.email,
                };
            });
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idproduto: this.idProduto,
                    idfornecedor: m.idfornecedor,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.fornecedoresSelecionados.length > 0) {
                this.isLoading = true;
                
                this.service.save(this.mapOnSave(this.fornecedoresSelecionados))
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>